module.exports = __webpack_public_path__ + "static/media/visual_search_onboarding_welcome.2b70c831.png";